import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    ColumnChooser,
    Paging,
    Scrolling,
    Export,
    Summary,
    TotalItem,
    GroupPanel,
    Grouping,
    GroupItem
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view';
import { Popup } from 'devextreme-react/popup';
import { showToast } from "../../utils/Utils";
import { ToastType } from "../../constants/Constants";
import TesvikFarkRaporDetay from '../tesvikraporfark/TesvikFarkRaporDetay';
import { parseDate ,hasRole} from "../../utils/Utils";
import './TesvikFarkRapor.scss';
//import ExcelJS from 'exceljs';
//import saveAs from 'file-saver';
/*
  // Use this import for codeSandBox
  import FileSaver from "file-saver";
*/
import { exportDataGrid } from 'devextreme/excel_exporter';


const TesvikFarkRapor = (props) => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            raporFarkIslemleri: hasRole("tesvikRapor|tesvikRaporFarkIslemleri|raporFarkIslemleri"),   
        });

    const listeBasligi = "Teşvik Rapor Fark";
    const [store, setStore] = useState(null);
    const [tesvikFarkRaporDetayData, setTesvikFarkRaporDetayData] = useState({ popupState: false, data: [] });

    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);

    const [treeBoxDonemValue, setTreeBoxDonemValue] = useState([]);
    const [treeDataDonemSource, setTreeDataDonemSource] = useState([]);

    useEffect(() => {
        domainListYukle();
        donemListYukle();
        setStore(new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                return []
            }
        }));
    }, [])

    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }
    const donemListYukle = () => {

        const request = new Request("/donem/getKayitList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    response.data.data.map(d => {
                        d.tarih = parseDate(d.tarih);
                    });
                    let datas = [];
                    let simdi = new Date();
                    response.data.data.map(d => {
                        if (d.tarih.getTime() < simdi.getTime()) {
                            datas.push(d);
                        }
                    });
                    // datas.sort((a,b) =>
                    //     a.tarih.getTime() - b.tarih.getTime()
                    // ).reverse();
                    // debugger;
                    let yils = [];
                    let yilDatas = [];
                    datas.map(d => {
                        let parentYil = parseInt(d.donem.substring(0, 4)) * -1;
                        d.parentid = parentYil;
                        if (yils.indexOf(parentYil) == -1) {
                            yils.push(parentYil);
                            let donemTmp = (parentYil * -1).toString();


                            yilDatas.push({ donem: donemTmp, id: parentYil, parentid: 0 });
                        }
                    });
                    yilDatas.map(d => {
                        datas.push(d);
                    });

                    setTreeDataDonemSource(datas);
                } else {
                    return []
                }
            });
    }

    let dataGrid = null;
    let treeView = null;
    let treeViewDonem = null;


    const getStore = () => {

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                //
                // const request = new Request("/tesvikRaporIslemleri/getKayitListByDonemFark/"+ props.data.domainId  +"/1" , "GET");

                let donems = treeBoxDonemValue;

                let donemsTemp = [];
                donems.map(d => {
                    if (d > 0) {
                        donemsTemp.push(d);
                    }
                });
                let data = {};
                data.donems = donemsTemp;
                data.domains = treeBoxValue;



                const request = new Request("/tesvikRaporFarkIslemleri/getKayitListByDonemFark", "POST", data);
                return request.run()
                    .then(response => {

                        if (response.data) {

                            let id = 1;
                            response.data.data.map(d => {
                                d.hesapDonemTar = parseDate(d.hesapDonemTar);
                                d.id = id;
                                id++;
                                if(d.personelTesvikList != null && d.personelTesvikList.length >0){
                                    d.personelTesvikList.map(dd => {
                                         dd.parent = d;
                                    });
                                }
                            });
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }
    const yenile = () => {


        let domains = treeBoxValue;
        let donems = treeBoxDonemValue;

        let donemsTemp = [];
        let simdi = new Date();
        donems.map(d => {
            if (d > 0) {
                donemsTemp.push(d);
            }
        });
        if (donems.length == 0) {
            showToast('Dönem Seçiniz', ToastType.ERROR, 500);
            return;
        }
        if (domains.length == 0) {
            showToast('Firma Seçiniz', ToastType.ERROR, 500);
            return;
        }
        // if (domains.length > 40) {
        //     showToast('Hesaplanacak Firma sayısı 40 dan büyük olamaz', ToastType.ERROR, 500);
        //     return;
        // }
        if (donemsTemp.length > 48) {
            showToast('Hesaplanacak Dönem sayısı 48 ten fazla olamaz', ToastType.ERROR, 500);
            return;
        }

        setStore(getStore());
    }

    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    }


    const syncTreeViewDonemSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeViewDonem && treeViewDonem.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxDonemValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxDonemValue([]);
            } else {
                setTreeBoxDonemValue(e.value);
            }
        }
    }

    const treeViewDonem_itemSelectionChanged = (e) => {
        setTreeBoxDonemValue(e.component.getSelectedNodeKeys());
    }

    const treeViewDonemRender = () => {
        return (
            <TreeView dataSource={treeDataDonemSource}
                ref={(ref) => treeViewDonem = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parentid"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="donem"
                selectByClick={true}
                onContentReady={syncTreeViewDonemSelection}
                onItemSelectionChanged={treeViewDonem_itemSelectionChanged}
            />
        );
    }


    function siraRender(data) {
        return (data.rowIndex + 1);// <b>{(data.rowIndex +1)}</b> ;
    }

    const raporFarkDetayOlustur = (data) => {
        setTesvikFarkRaporDetayData({
            popupState: true,
            data: data.personelTesvikList
        });
    }
    function hideTesvikRaporFarkDetayPopup() {
        setTesvikFarkRaporDetayData({ popupState: false, data: {} })
    }
    function onExporting(e) {

        let fileName = "";
        treeDataSource.map(sd => {
            if (treeBoxValue.indexOf(sd.id) > -1 && sd.sicilNo != null && sd.sicilNo != "") {
                fileName += sd.name;

            }
        });

        if (fileName == "") {
            fileName = "RaporFark";
        }
        fileName = fileName.substring(0, 100);

        e.fileName = fileName;

        //e.cancel = true;
    }
    function onToolbarPreparingDetay(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            //template: 'totalGroupCount'
        }, {
            location: 'after',
            widget: 'dxButton', 
            options: {
                icon: 'download',
                
                onClick: () => {
                    showAllData();
                }
            }
        } );
    }
    function showAllData(){
        let grid =dataGrid;
        let datasource =grid.instance.getDataSource()
        let items = datasource._items

        let array =[];
        items.map(dd => {
            dd.items.map(ddd => {
                ddd.items.map(dddd => {
                    dddd.personelTesvikList.map(ddddd => {
                        array.push(ddddd);
                   });
                });    
            }); 
       });

        setTesvikFarkRaporDetayData({
            popupState: true,
            data:array
        });
    }

    return (
        <div >
            {/* <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{marginLeft: "10px"}}>
                </div>
            </div> */}


            <h2 className={'dx-icon-product'} >{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    <DropDownBox
                        value={treeBoxValue}
                        valueExpr="id"
                        displayExpr="name"
                        placeholder="Firma Seçiniz..."
                        showClearButton={true}
                        dataSource={treeDataSource}
                        onValueChanged={syncTreeViewSelection}
                        contentRender={treeViewRender}
                        width="500"
                    />
                    <DropDownBox
                        value={treeBoxDonemValue}
                        valueExpr="id"
                        displayExpr="donem"
                        placeholder="Dönem Seçiniz..."
                        showClearButton={true}
                        dataSource={treeDataDonemSource}
                        onValueChanged={syncTreeViewDonemSelection}
                        contentRender={treeViewDonemRender}
                        width="500"
                    />
                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                        onClick={yenile}></Button>
                </div>
            </div>

            <DataGrid
                className="tesvikRaporFarkListesiGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                //height="500px"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{ mode: 'single', deferred: true }}
                onExporting={onExporting}
                onToolbarPreparing={onToolbarPreparingDetay}
            //remoteOperations={true}
            >
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={true} />
                {/* <SearchPanel visible={true} /> */}
                {/* <FilterRow visible={true} /> */}
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />

                {/* <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100, 200]} showInfo={true}  visible={true} />
                <Paging defaultPageSize={10} /> */}

                <Column width={30} caption={'Sıra'} dataType="number" visible={true} cellRender={siraRender} />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'domain.name'} width={200} caption={'Firma'} dataType="string" visible={true} groupIndex={0} />
                <Column dataField={'domain.sicilNo'} width={100} caption={'SicilNo'} dataType="string" visible={true} groupIndex={0} />
                <Column dataField="hesapDonemTar" width={70} caption={'Hesap-Dönem'} dataType="date" format="yyyy/MM" visible={true} />
                <Column dataField={'calisanSayi6111'} width={50} caption={'6111 Çalışan sayı'} dataType="number" visible={true} />
                <Column dataField={'calisanSayi7103'} width={50} caption={'7103 Çalışan Sayı'} dataType="number" visible={true} />
                <Column dataField={'danismanTutar'} width={150} caption={'Hesaplanan Teşvik Tutar'} dataType="number" visible={true} />
                <Column dataField={'firmaTutar'} width={150} caption={'Kullanılmış Teşvik Tutarı'} dataType="number" visible={true} />
                <Column dataField={'fark'} width={150} caption={'Fark'} dataType="number" visible={true} />
                <Column dataField={'hazineIndirim'} width={150} caption={'Hazine İndirim'} dataType="number" visible={true} />
                <Column dataField={'mesaj'} width={200} caption={'Dönem mesaj'} dataType="string" visible={true} />
                <Column type="buttons" caption={'İşlem'} width={70}
                    buttons={[
                        { hint: 'Detay', icon: 'detailslayout', visible: true, onClick: (e) => { raporFarkDetayOlustur(e.row.data); } },
                    ]}
                />
                <Summary>
                    <GroupItem
                        column="danismanTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />

                    <GroupItem
                        column="firmaTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />

                    <GroupItem
                        column="fark"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />
                    <TotalItem
                        column="cvLikTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" />
                    <TotalItem
                        column="firmaTutar"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" />
                    <TotalItem
                        column="fark"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" />
                    <TotalItem
                        column="hazineIndirim"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" />
                </Summary>

            </DataGrid>

            <Popup
                visible={tesvikFarkRaporDetayData.popupState}
                onHiding={hideTesvikRaporFarkDetayPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Teşvik Rapor Fark Detay"
                width={1000}
                height={600}
            >
                <div>
                    {tesvikFarkRaporDetayData.popupState ? <TesvikFarkRaporDetay data={tesvikFarkRaporDetayData.data} hide={hideTesvikRaporFarkDetayPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideTesvikRaporFarkDetayPopup}
                    />
                </div>
            </Popup>
        </div>
    )
}

export default TesvikFarkRapor;
